<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string;
    disabled?: boolean;
  }>(),
  {}
);
</script>

<template>
  <button v-bind="$attrs" :disabled="disabled" class="dr-btn-link">
    {{ label }}
  </button>
</template>

<style lang="scss" scoped>
.dr-btn-link {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 1rem;
  padding: 0;
}
</style>
